module.exports = __webpack_public_path__ + "static/media/MRI.e0a07648.png";